import { render, staticRenderFns } from "./money.vue?vue&type=template&id=6f3ca376&scoped=true&"
import script from "./money.vue?vue&type=script&lang=js&"
export * from "./money.vue?vue&type=script&lang=js&"
import style0 from "./money.vue?vue&type=style&index=0&id=6f3ca376&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ca376",
  null
  
)

export default component.exports